export const COOKIES_AGREEMENT_ACCEPTED_KEY = 'cookie_agreement_accepted';

export const MOBILE_APP_FULLSCREEN_BANNER_COOKIE_NAME = 'number_banner_appearances';

export const QA_TEST_MODE = 'QA-TestMode';
